import React from 'react';
import { css } from '@kufox/mui/emotion';
import { DownloadAppOutlined } from '@kufox/icons';
import Dropdown from '@kufox/mui/Dropdown';
import useTheme from '@kufox/mui/hooks/useTheme';
import QRCode from 'qrcode.react';
import Link from '../../components/Link';
// import downloadLogo from '../../../static/download/logo_icon.png';
import downloadLogo from '../../../static/download/logo-icon.svg';

import { useLang } from '../../hookTool';
import { addSpmIntoQuery } from '../../common/tools';
import DownIcon from '../../../static/download/down-icon.svg';

const useStyles = ({ color }) => {
  return {
    appDownloadWrapper: css`
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      & img {
        width: 16px;
      }

      &:hover {
        opacity: 0.6;
      }
      &:active {
        opacity: 1;
      }
    `,
    appDownloadIcon: css`
      margin-right: 6px;
    `,
    overlayWrapper: css`
      margin-top: 22px;
      padding: 16px 20px;
      background: ${color.base};
      box-shadow: 0px 10px 60px rgba(0, 0, 0, 0.1);
      border-radius: 4px;
      & .title {
        color: ${color.text};
        font-size: 14px;
        line-height: 1.4;
        width: 160px;
        word-break: break-word;
        margin-bottom: 16px;
        white-space: normal;
      }
      & .QRCode {
        margin-bottom: 16px;
        padding: 4px;
        background: #fff;
        & .QRCodeBox {
          background: ${color.base};
          line-height: 1.5;
          position: relative;
        }
      }
      & .more {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 5px 0;
        color: #fff;
        font-size: 14px;
        line-height: 22px;
        text-decoration: none !important;
        border-radius: 4px;
        background: ${color.primary};
      }
    `,
    iconDown: css`
      width: 12px;
      height: 12px;
      margin-left: 4px;
    `,
  };
};

const DownloadBox = (props) => {
  const { currentLang, hostConfig } = props;
  const { KUCOIN_HOST, KUCOIN_HOST_CHINA } = hostConfig;
  const theme = useTheme();
  const classes = useStyles({ color: theme.colors });

  const { t } = useLang();

  const Overlay = () => {
    const apkUrl = `${
      currentLang === 'zh_CN' ? KUCOIN_HOST_CHINA : KUCOIN_HOST
    }/download?lang=${currentLang}`;
    return (
      <div css={classes.overlayWrapper}>
        <div className="title">{t('newhomepage.down.title.2')}</div>
        <div className="QRCode">
          <div className="QRCodeBox">
            <QRCode
              value={apkUrl}
              size={160}
              level="M"
              imageSettings={{
                src: downloadLogo,
                x: null,
                y: null,
                height: 32,
                width: 32,
                excavate: true,
              }}
            />
          </div>
        </div>
        <Link
          href={addSpmIntoQuery(`${KUCOIN_HOST}/download`, ['appDowload', '1'], currentLang)}
          className="more"
          data-modid="appDowload"
          lang={currentLang}
        >
          {t('newhomepage.down.more')}
          <img src={DownIcon} css={classes.iconDown} alt="" />
        </Link>
      </div>
    );
  };
  return (
    <Dropdown
      overlay={<Overlay />}
      trigger="hover"
      anchorProps={{ style: { display: 'block' } }}
      placement="bottom-end"
    >
      <div css={classes.appDownloadWrapper}>
        <DownloadAppOutlined size="24" className="navIcon" />
      </div>
    </Dropdown>
  );
};

export default DownloadBox;
